import { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface ResizeProps {
    box?: 'border-box' | 'content-box' | 'device-pixel-content-box';
    children: any;
}

export default function Resize({ box = 'border-box', children }: ResizeProps) {
    const ref: any = useRef();
    const [height, setHeight] = useState(-1);
    useLayoutEffect(() => {
        let observer = new ResizeObserver(onResize);
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    function onResize() {
        setHeight(ref.current.offsetHeight);
    }

    return (
        <Wrapper style={{ height: height >= 0 ? `${height}px` : 'unset' }}>
            <div ref={ref}>{children}</div>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    transition: height var(--ui-animation-duration);
    overflow: hidden;
`;